import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco, Externo } from "./util";

/** O que cada leitura destaca: ordem sorteada e nome posto pelo servidor (Princípio III). */
export function Leituras({ vista, numero }: { vista: VistaCard; numero: number }) {
  const leituras = vista.leituras ?? [];
  if (!leituras.length) return null;
  return (
    <Bloco numero={numero} titulo="O que cada leitura destaca">
      <ul>
        {leituras.map((l) => (
          <li key={l.url}>
            <strong>{l.nome}:</strong> {l.texto}
            <br />
            <span className={estilos.fonte}>
              Documento: <Externo href={l.url}>{l.documento}</Externo>, consultado em {l.data}.
              Trecho: <span className={estilos.trecho}>{l.trecho}</span>
            </span>
          </li>
        ))}
      </ul>
      {vista.leituras_aviso && <p className={estilos.fonte}>{vista.leituras_aviso}</p>}
    </Bloco>
  );
}
